import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/goods/")({
  beforeLoad: () => {
    throw redirect({
      to: "/goods/selectionLog",
      search: { productName: undefined, promotionStatus: undefined },
    });
  },
});
